var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"card-hoverable"},[_c('b-col',{staticClass:"m-auto",attrs:{"cols":"12"}},[_c('div',{staticClass:"box-image image m-auto"},[_vm._t("p-1")],2)]),_vm._t("p-2"),_vm._t("p-3")],2)}
var staticRenderFns = []

export { render, staticRenderFns }